function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #balaSVG .cls-1 {\n        fill: none;\n      }\n\n      #balaSVG .cls-1, #balaSVG .cls-3 {\n        stroke: #f5f5f5;\n        stroke-miterlimit: 10;\n      }\n\n      #balaSVG .cls-2 {\n        fill: url(#Gradiente_sem_nome_399);\n      }\n\n      #balaSVG .cls-3 {\n        fill: #f5f5f5;\n        stroke-width: 0.3px;\n      }\n\n    "), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Gradiente_sem_nome_399",
  x1: 0.5,
  y1: 26.03,
  x2: 50.5,
  y2: 26.03,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ed1c24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#ed5c6d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94,
  stopColor: "#ed6679"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "balaSVG"
}, /*#__PURE__*/React.createElement("g", {
  id: "Fundo_Bala"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Fundo_Bala-2",
  "data-name": "Fundo Bala",
  className: "cls-2",
  cx: 26,
  cy: 25.5,
  r: 25
})), /*#__PURE__*/React.createElement("g", {
  id: "Borda_Bala"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Borda_Bala-2",
  className: "cls-1",
  cx: 26,
  cy: 25.5,
  r: 25
})), /*#__PURE__*/React.createElement("g", {
  id: "Bala"
}, /*#__PURE__*/React.createElement("path", {
  id: "Bala-2",
  className: "cls-3",
  d: "M26.21,9.15A16.62,16.62,0,1,0,42.83,25.77,16.63,16.63,0,0,0,26.21,9.15Zm11.71,6.52a15.53,15.53,0,0,1,3.4,6.79l-.71-.09A21.29,21.29,0,0,0,28.1,24.45a7,7,0,0,0-1.71,1.08l-.07.07.21-.5A16.7,16.7,0,0,1,37.92,15.67Zm-23.11-.35.38.65A24.18,24.18,0,0,0,24,24.88l1.37.8-.26,0A18.61,18.61,0,0,1,12.44,22l-1-.77A15.44,15.44,0,0,1,14.81,15.32ZM36.83,37c-1-2.07-5.18-10-10.42-10.91L26.18,26l.45.69a18.49,18.49,0,0,1,2.81,12.89l-.19,1.32a15.29,15.29,0,0,1-3,.31,15.54,15.54,0,0,1-4.65-.72c1.36-1.89,6.34-9.31,4.64-14.33L26.15,26l-.4.73a18.52,18.52,0,0,1-10,8.59l-1.34.49a15.43,15.43,0,0,1-3.14-6c2.38.1,11.24.19,14.49-4l.17-.17-.48,0-.36-.62a18.59,18.59,0,0,1-2.18-13l.29-1.45a15.75,15.75,0,0,1,3-.29,15.59,15.59,0,0,1,3.3.35l-.44.71a21.28,21.28,0,0,0-3.23,12.27,7.21,7.21,0,0,0,.29,2l.08.23.07-.17.76,0a19.1,19.1,0,0,1,13.65,5.53A15.63,15.63,0,0,1,36.83,37Z"
})));

function SvgBala(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBala);
export default __webpack_public_path__ + "static/media/Bala.f652face.svg";
export { ForwardRef as ReactComponent };